import { createBrowserRouter } from 'react-router';

import { AppLayout } from './components/AppLayout';
import { LoggedOutPage } from './pages/LoggedOutPage';
import { PaymentsPage } from './pages/PaymentsPage';
import { ReportsPage } from './pages/ReportsPage';
import { SettingsPage } from './pages/SettingsPage';
import { SubscriptionsPage } from './pages/SubscriptionsPage';

/**
 * Route stubs only (PLAN.md milestone 5/6 fills the pages in).
 * react-router v7, library mode.
 *
 * `/logged-out` sits OUTSIDE the shell on purpose — it is the dead end the api
 * 302s to after destroying the session, and it must not run the shell's
 * identity probe (see `LoggedOutPage`).
 */
export const router = createBrowserRouter([
  { path: '/logged-out', element: <LoggedOutPage /> },
  {
    path: '/',
    element: <AppLayout />,
    children: [
      { index: true, element: <SubscriptionsPage /> },
      { path: 'subscriptions', element: <SubscriptionsPage /> },
      { path: 'payments', element: <PaymentsPage /> },
      { path: 'reports', element: <ReportsPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
]);
